"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const baseStyle = {
  container: {
    _disabled: {
      cursor: 'not-allowed'
    }
  },
  control: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderImage: 'initial',
    borderRadius: 'sm',
    borderColor: 'gray.600',
    transition: 'all 150ms ease',
    marginTop: 1.5,
    _readOnly: {
      boxShadow: 'none !important',
      userSelect: 'all'
    },
    _disabled: {
      cursor: 'not-allowed',
      userSelect: 'none',
      borderColor: 'gray.200'
    },
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    },
    _checked: {
      borderColor: 'primary.default',
      backgroundColor: 'primary.default',
      _hover: {
        borderColor: 'primary.600',
        backgroundColor: 'primary.600'
      },
      _disabled: {
        borderColor: 'gray.200',
        backgroundColor: 'gray.200'
      }
    },
    '& svg': {
      filter: `drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))`
    }
  },
  label: {
    _disabled: {
      color: 'gray.200',
      cursor: 'not-allowed'
    }
  },
  icon: {
    color: 'white'
  }
};
const sizes = {
  sm: {
    control: {
      marginTop: '0.3125rem'
    }
  },
  md: {
    control: {
      marginTop: 1
    },
    label: {
      fontSize: 'base'
    }
  },
  lg: {
    control: {
      marginTop: 1
    },
    label: {
      fontSize: 'md'
    }
  }
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Checkbox, {
  baseStyle,
  sizes
});